import { render, staticRenderFns } from "./SchoolAwayDetailModal.vue?vue&type=template&id=e87f8c04&scoped=true&"
import script from "./SchoolAwayDetailModal.vue?vue&type=script&lang=js&"
export * from "./SchoolAwayDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87f8c04",
  null
  
)

export default component.exports